import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const Link = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.as]
 * @param {string} props.href
 * @param {"primary" | "secondary" | "tertiary"} [props.variant]
 * @param {any} [props.className]
 * @param {any} [props.children]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Link({
  as: El,
  href,
  variant,
  className,
  ...props
}, ref) {
  const linkClass = classNames({
    "text-en-yellow-600 font-bold": variant === "primary",
    "text-en-gray-800 font-bold": variant === "secondary",
    underline: variant === "tertiary"
  }, className);
  const linkProps = El === "a" ? {
    href,
    ...props
  } : {
    to: href,
    ...props
  };
  return /*#__PURE__*/React.createElement(El, _extends({
    className: linkClass
  }, linkProps, {
    ref: ref
  }));
});
Link.defaultProps = {
  as: "a"
};
Link.propTypes = {
  as: PropTypes.elementType,
  href: PropTypes.string,
  // @ts-ignore
  variant: PropTypes.string,
  className: PropTypes.string
};